<template>
  <div id="home">
    <v-container grid-list-xl fluid class="ma-0 pa-3">
      <v-layout row wrap v-if="configuracion">
        <v-flex lg2 sm12 xs12>
          <v-card class="elevation-4" v-if="true">
            <v-toolbar dense color="primary" dark flat>
              <v-toolbar-title>{{ $t("otros.configuracion") }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <b>{{ $t("domicilios.cabecera.nombre") }}</b>
              <br />
              {{ configuracion.NombreConfiguracion }}
              <br />
              <br />

              <b>{{ $t("servicios.formulario.fecha") }}</b>
              <br />
              {{ configuracion.FechaConfiguracion }}
              <br />

              <v-switch
                v-model="ocultarCamposCargados"
                :label="$t('servicios.ocultarCamposCargados')"
              ></v-switch>
              <p v-if="false">{{ JSON.stringify(configuracion) }}</p>
              <p v-if="false">{{ JSON.stringify(servicio) }}</p>
            </v-card-text>
            <div
              style="
                 {
                  text-align: center;
                }
              "
              v-if="false"
            >
              <upload-button
                :title="$t('servicios.importar')"
                :selectedCallback="cargarConfiguracion"
                color="primary"
                :buttonIcon="false"
              />
            </div>
          </v-card>
        </v-flex>

        <v-flex lg10 sm12 xs12 :class="isMobile ? '' : 'ml-0 pl-0'">
          <v-card class="elevation-4">
            <v-toolbar :extended="false" color="primary" dark dense flat>
              <v-toolbar-title>{{
                $t("servicios.servicioRapido")
              }}</v-toolbar-title>
              <v-spacer />
              <v-btn flat color="white" @click="procesarConfiguracion">
                <v-icon class="pr-1">settings_backup_restore</v-icon>
                {{ $t("servicios.formulario.reiniciar") }}
              </v-btn>

              <v-btn flat color="white" @click="guardar(false)">
                <v-icon class="pr-1">save</v-icon>
                {{ $t("servicios.formulario.grabarServicio") }}
              </v-btn>

              <v-btn flat color="white" @click="guardar(true)">
                <v-icon class="pr-1">print</v-icon>
                {{ $t("servicios.formulario.grabarServicioImprimir") }}
              </v-btn>
            </v-toolbar>

            <v-card-text v-if="servicio">
              <!--Bloque datos generales -->
              <v-layout row wrap>
                <v-flex
                  class="pa-2"
                  xs12
                  sm6
                  md3
                  v-if="!esCampoOculto('CodigoTipoServicio')"
                >
                  <b-form-group
                    id="serviceType"
                    :label="
                      $t('servicios.formularioExpedicion.tipoServicio') +
                      ' - (' +
                      servicio.CodigoTipoServicio +
                      ')'
                    "
                    label-for="serviceType"
                  >
                    <v-layout wrap>
                      <v-flex sm9 class="pr-0 mr-0">
                        <b-select
                          v-model="servicioSeleccionado"
                          @input="actualizarServicio"
                        >
                          <option
                            v-for="TipoServicio in servicesTypes"
                            :value="TipoServicio"
                            :key="TipoServicio.CODIGO"
                          >
                            {{ TipoServicio.NOMBRE }}
                          </option>
                        </b-select>
                      </v-flex>
                      <v-flex sm3 class="pl-0 ml-0">
                        <b-btn @click="cargarTiposServicio">
                          {{ $t("servicios.formularioExpedicion.refrescar") }}
                        </b-btn>
                      </v-flex>
                    </v-layout>
                  </b-form-group>
                </v-flex>

                <v-flex
                  class="pa-2"
                  xs12
                  md1
                  v-if="false && !esCampoOculto('CodigoTipoServicio')"
                >
                  <v-text-field
                    :label="$t('servicios.codigoTipoServicio')"
                    v-model="servicio.CodigoTipoServicio"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="pa-2 pt-3"
                  xs12
                  sm6
                  md3
                  v-if="!esCampoOculto('Referencia')"
                >
                  <v-text-field
                    :label="$t('servicios.formulario.referencia')"
                    v-model="servicio.Referencia"
                  ></v-text-field>
                </v-flex>

                <v-flex class="pa-2" xs12 sm6 md3>
                  <!-- Fecha -->
                  <b-form-group
                    center
                    id="date"
                    :label="$t('servicios.formulario.fecha')"
                    label-for="date"
                  >
                    <b-form-input
                      autocomplete="off"
                      id="date"
                      type="date"
                      v-model="servicio.Fecha"
                      @change="establecerHorarioRecogida"
                    ></b-form-input>
                  </b-form-group>
                </v-flex>

                <v-flex class="pa-2 pt-3" xs12 sm6 md3>
                  <v-checkbox
                    color="primary"
                    v-model="servicio.SolicitudCliente"
                    :label="$t('servicios.formulario.solicitudRecogidaPlaza')"
                  ></v-checkbox>
                </v-flex>
              </v-layout>

              <!--Bloque remitente -->
              <div v-if="!esCampoOculto('Remitente_Direccion')">
                <v-toolbar dense flat color="white">
                  <v-toolbar-title class="pa-0 ma-0">Remitente</v-toolbar-title>
                  <v-spacer />
                  <v-spacer />
                  <v-spacer />
                  <v-spacer />
                  <v-autocomplete
                    v-model="selectedAddressRemitente"
                    :items="addresses"
                    :label="$t('domicilios.formulario.seleccionaDireccion')"
                    return-object
                    browser-autocomplete="off"
                    clearable
                    item-text="Filtro"
                    item-value="Id"
                    :input="estableceDireccionRemitente()"
                  >
                    <template slot="selection" slot-scope="data"
                      >{{ data.item.Codigo }} - {{ data.item.Nombre }}</template
                    >

                    <template slot="item" slot-scope="data">
                      <v-content v-if="typeof data.item !== 'object'">
                        <v-list-tile-content
                          v-text="data.item"
                        ></v-list-tile-content>
                      </v-content>
                      <v-content v-else>
                        <v-layout row wrap>
                          <v-flex xs3>{{ data.item.Codigo }}</v-flex>
                          <v-flex xs9>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{ data.item.Nombre }}
                              </v-list-tile-title>
                              <v-list-tile-sub-title>
                                {{ data.item.Poblacion }} -
                                {{ data.item.Direccion }}
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-flex>
                        </v-layout>
                      </v-content>
                    </template>

                    <template v-slot:no-data>
                      <v-list-tile>
                        <v-list-tile-title>No hay resultados</v-list-tile-title>
                      </v-list-tile>
                    </template>
                  </v-autocomplete>
                </v-toolbar>
                <v-layout row wrap>
                  <v-flex
                    class="pa-2"
                    xs12
                    sm6
                    md3
                    v-if="!esCampoOculto('Remitente_Nombre')"
                  >
                    <v-text-field
                      :label="$t('domicilios.formulario.nombreApellidos')"
                      ref="NombreApellido"
                      v-model="servicio.Remitente.Nombre"
                      required
                      :rules="validations.standarRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    class="pa-2"
                    xs12
                    sm6
                    md3
                    v-if="!esCampoOculto('Remitente_Email')"
                  >
                    <v-text-field
                      label="Email"
                      v-model="servicio.Remitente.Email"
                      required
                      :rules="validations.emailRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    class="pa-2"
                    xs12
                    sm6
                    md3
                    v-if="!esCampoOculto('Remitente_Telefono')"
                  >
                    <v-text-field
                      :label="$t('domicilios.formulario.telefono')"
                      v-model="servicio.Remitente.Telefono"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    class="pa-2"
                    xs12
                    sm6
                    md3
                    v-if="!esCampoOculto('Remitente_Nif')"
                  >
                    <v-text-field
                      label="NIF"
                      v-model="servicio.Remitente.Nif"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    class="pa-2"
                    xs12
                    sm6
                    md3
                    v-if="!esCampoOculto('Remitente_Pais')"
                  >
                    <v-text-field
                      :label="$t('domicilios.formulario.pais')"
                      v-model="servicio.Remitente.Pais"
                      required
                      :rules="validations.standarRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    class="pa-2"
                    xs12
                    sm6
                    md3
                    v-if="!esCampoOculto('Remitente_CodigoPostal')"
                  >
                    <v-text-field
                      :label="$t('domicilios.formulario.codigoPostal')"
                      v-model="servicio.Remitente.CodigoPostal"
                      required
                      :rules="validations.standarRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    class="pa-2"
                    xs12
                    sm6
                    md3
                    v-if="!esCampoOculto('Remitente_Poblacion')"
                  >
                    <v-text-field
                      :label="$t('domicilios.formulario.poblacion')"
                      v-model="servicio.Remitente.Poblacion"
                      required
                      :rules="validations.standarRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    class="pa-2"
                    xs12
                    sm6
                    md3
                    v-if="!esCampoOculto('Remitente_Provincia')"
                  >
                    <v-text-field
                      :label="$t('domicilios.formulario.provincia')"
                      v-model="servicio.Remitente.Provincia"
                      :rules="validations.standarRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    class="pa-2"
                    xs6
                    v-if="!esCampoOculto('Remitente_Direccion')"
                  >
                    <v-text-field
                      :label="$t('domicilios.formulario.direccion')"
                      v-model="servicio.Remitente.Direccion"
                      required
                      :rules="validations.standarRules"
                    ></v-text-field>
                  </v-flex>

                  <v-flex
                    class="pa-2"
                    xs6
                    v-if="!esCampoOculto('Remitente_Observacion')"
                  >
                    <v-text-field
                      :label="$t('domicilios.formulario.observaciones')"
                      v-model="servicio.Remitente.Observacion"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </div>

              <!--Bloque Destinatario -->
              <v-toolbar dense flat color="white">
                <v-toolbar-title class="pa-0 ma-0"
                  >Destinatario</v-toolbar-title
                >
                <v-spacer />
                <v-spacer />
                <v-spacer />
                <v-spacer />
                <v-autocomplete
                  v-model="selectedAddressDestinatario"
                  :items="addresses"
                  :label="$t('domicilios.formulario.seleccionaDireccion')"
                  return-object
                  :input="estableceDireccionDestinatario()"
                  browser-autocomplete="off"
                  clearable
                  item-text="Filtro"
                  item-value="Id"
                >
                  <template slot="selection" slot-scope="data"
                    >{{ data.item.Codigo }} - {{ data.item.Nombre }}</template
                  >

                  <template slot="item" slot-scope="data">
                    <v-content v-if="typeof data.item !== 'object'">
                      <v-list-tile-content
                        v-text="data.item"
                      ></v-list-tile-content>
                    </v-content>
                    <v-content v-else>
                      <v-layout row wrap>
                        <v-flex xs3>{{ data.item.Codigo }}</v-flex>
                        <v-flex xs9>
                          <v-list-tile-content>
                            <v-list-tile-title>
                              {{ data.item.Nombre }}
                            </v-list-tile-title>
                            <v-list-tile-sub-title>
                              {{ data.item.Poblacion }} -
                              {{ data.item.Direccion }}
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-flex>
                      </v-layout>
                    </v-content>
                  </template>

                  <template v-slot:no-data>
                    <v-list-tile>
                      <v-list-tile-title>No hay resultados</v-list-tile-title>
                    </v-list-tile>
                  </template>
                </v-autocomplete>
              </v-toolbar>

              <v-layout row wrap>
                <v-flex
                  class="pa-2"
                  xs12
                  sm6
                  md3
                  v-if="!esCampoOculto('Destinatario_Nombre')"
                >
                  <v-text-field
                    :label="$t('domicilios.formulario.nombreApellidos')"
                    ref="NombreApellido"
                    v-model="servicio.Destinatario.Nombre"
                    required
                    :rules="validations.standarRules"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs12
                  sm6
                  md3
                  v-if="!esCampoOculto('Destinatario_Email')"
                >
                  <v-text-field
                    label="Email"
                    v-model="servicio.Destinatario.Email"
                    required
                    :rules="validations.emailRules"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs12
                  sm6
                  md3
                  v-if="!esCampoOculto('Destinatario_Telefono')"
                >
                  <v-text-field
                    :label="$t('domicilios.formulario.telefono')"
                    v-model="servicio.Destinatario.Telefono"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs12
                  sm6
                  md3
                  v-if="!esCampoOculto('Destinatario_Nif')"
                >
                  <v-text-field
                    label="NIF"
                    v-model="servicio.Destinatario.Nif"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs12
                  sm6
                  md3
                  v-if="!esCampoOculto('Destinatario_Pais')"
                >
                  <v-text-field
                    :label="$t('domicilios.formulario.pais')"
                    v-model="servicio.Destinatario.Pais"
                    required
                    :rules="validations.standarRules"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs12
                  sm6
                  md3
                  v-if="!esCampoOculto('Destinatario_CodigoPostal')"
                >
                  <v-autocomplete
                    ref="autocompleteCodigoPostal"
                    v-model="servicio.Destinatario.CodigoPostal"
                    :loading="loading"
                    :items="CodigosPostales"
                    hide-no-data
                    hide-details
                    :search-input.sync="CodigoPostal_s"
                    :label="$t('domicilios.formulario.codigoPostal')"
                    @change="filtrarAPI()"
                    @click:clear="filtrarAPI()"
                    :rules="validations.codigoPostalDestinatario"
                    tabindex="0"
                    v-if="destinatarioPaisCercano"
                  ></v-autocomplete>
                  <v-text-field
                    :label="$t('domicilios.formulario.codigoPostal')"
                    v-model="servicio.Destinatario.CodigoPostal"
                    required
                    :rules="validations.standarRules"
                    v-else
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs12
                  sm6
                  md3
                  v-if="!esCampoOculto('Destinatario_Poblacion')"
                >
                  <v-autocomplete
                    tabindex="0"
                    ref="autocompletePoblacion"
                    v-model="servicio.Destinatario.Poblacion"
                    :loading="loading"
                    :items="Poblaciones"
                    hide-no-data
                    menu-props="openOnHover"
                    hide-details
                    :search-input.sync="Poblacion_s"
                    :label="$t('domicilios.formulario.poblacion')"
                    @change="filtrarAPI()"
                    @click:clear="filtrarAPI()"
                    :rules="validations.standarRules"
                    v-if="destinatarioPaisCercano"
                  ></v-autocomplete>
                  <v-text-field
                    :label="$t('domicilios.formulario.poblacion')"
                    v-model="servicio.Destinatario.Poblacion"
                    required
                    :rules="validations.standarRules"
                    v-else
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs11
                  sm5
                  md2
                  v-if="!esCampoOculto('Destinatario_Provincia')"
                >
                  <v-autocomplete
                    ref="autocompleteProvincia"
                    v-model="servicio.Destinatario.Provincia"
                    :loading="loading"
                    :items="Provincias"
                    hide-no-data
                    hide-details
                    :search-input.sync="Provincia_s"
                    :label="$t('domicilios.formulario.provincia')"
                    readonly
                    @change="filtrarAPI()"
                    @click:clear="filtrarAPI()"
                    v-if="destinatarioPaisCercano"
                  ></v-autocomplete>
                  <v-text-field
                    :label="$t('domicilios.formulario.provincia')"
                    v-model="servicio.Destinatario.Provincia"
                    required
                    :rules="validations.standarRules"
                    v-else
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs1
                  v-if="!esCampoOculto('Destinatario_Provincia')"
                >
                  <v-btn round :loading="loading" @click="limpiarDireccion"
                    ><v-icon>clear</v-icon></v-btn
                  >
                </v-flex>
                <v-flex
                  class="pa-2"
                  xs6
                  v-if="!esCampoOculto('Destinatario_Direccion')"
                >
                  <v-text-field
                    :label="$t('domicilios.formulario.direccion')"
                    v-model="servicio.Destinatario.Direccion"
                    required
                    :rules="validations.standarRules"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="pa-2"
                  xs6
                  v-if="!esCampoOculto('Destinatario_Observacion')"
                >
                  <v-text-field
                    :label="$t('domicilios.formulario.observaciones')"
                    v-model="servicio.Destinatario.Observacion"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <!--Bloque expedicion -->
              <v-toolbar-title class="pa-0 ma-0">Expedición</v-toolbar-title>
              <v-layout row wrap>
                <v-flex
                  class="pa-2"
                  xs12
                  sm4
                  md2
                  v-if="!esCampoOculto('EntregaSabado')"
                >
                  <v-checkbox
                    color="primary"
                    v-model="servicio.EntregaSabado"
                    :label="$t('servicios.formularioExpedicion.entregaSabado')"
                  ></v-checkbox>
                </v-flex>

                <v-flex
                  class="pa-2"
                  xs12
                  sm4
                  md2
                  v-if="!esCampoOculto('AcuseRecibo')"
                >
                  <v-checkbox
                    color="primary"
                    v-model="servicio.AcuseRecibo"
                    :label="$t('servicios.formularioExpedicion.acuseRecibo')"
                  ></v-checkbox>
                </v-flex>

                <v-flex
                  class="pa-2"
                  xs12
                  sm4
                  md2
                  v-if="!esCampoOculto('Retorno')"
                >
                  <v-checkbox
                    color="primary"
                    v-model="servicio.Retorno"
                    :label="$t('servicios.formularioExpedicion.retorno')"
                  ></v-checkbox>
                </v-flex>

                <v-flex
                  class="pa-2"
                  xs12
                  sm4
                  md2
                  v-if="!esCampoOculto('Gestion')"
                >
                  <v-checkbox
                    color="primary"
                    v-model="servicio.Gestion"
                    :label="$t('servicios.formularioExpedicion.gestion')"
                  ></v-checkbox>
                </v-flex>

                <v-flex
                  class="pa-2"
                  xs12
                  sm4
                  md2
                  v-if="!esCampoOculto('AvisoEmailRemitente')"
                >
                  <v-checkbox
                    color="primary"
                    v-model="servicio.AvisoEmailRemitente"
                    :label="
                      $t('servicios.formularioExpedicion.envioEmailRemitente')
                    "
                  ></v-checkbox>
                </v-flex>

                <v-flex
                  class="pa-2"
                  xs12
                  sm4
                  md2
                  v-if="!esCampoOculto('AvisoEmailDestino')"
                >
                  <v-checkbox
                    color="primary"
                    v-model="servicio.AvisoEmailDestino"
                    :label="
                      $t('servicios.formularioExpedicion.envioEmailDestino')
                    "
                  ></v-checkbox>
                </v-flex>

                <v-flex class="pa-2" xs12>
                  <PackageList
                    class="pa-1 ma-0"
                    :puedoEditar="true"
                    :Bultos="servicio.Bultos"
                  ></PackageList>
                </v-flex>

                <v-flex class="pa-2" xs12 sm4 md2>
                  <b-form-group
                    id="insuredAmoun"
                    :label="
                      $t('servicios.formularioExpedicion.importeValorAsegurado')
                    "
                    label-for="insuredAmount"
                  >
                    <currency-input
                      :min="0"
                      v-model="servicio.ImporteValor"
                      class="demo__currency-input"
                    />
                    <v-chip v-if="servicio.ImporteValor > 0">
                      {{
                        $t("servicios.formularioExpedicion.aseguradoTodoRiesgo")
                      }}
                    </v-chip>
                  </b-form-group>
                </v-flex>

                <v-flex class="pa-2" xs12 sm4 md2>
                  <b-form-group
                    center
                    id="refundAmount"
                    :label="
                      $t('servicios.formularioExpedicion.importeReembolso')
                    "
                    label-for="refundAmount"
                  >
                    <currency-input
                      :min="0"
                      v-model="servicio.ImporteReembolso"
                      class="demo__currency-input"
                    />
                  </b-form-group>
                </v-flex>

                <v-flex class="pa-2 pt-3" xs12 sm4 md2>
                  <v-checkbox
                    color="primary"
                    v-model="servicio.ImporteDebido"
                    :label="$t('servicios.formularioExpedicion.porteDebido')"
                  ></v-checkbox>
                </v-flex>

                <v-flex class="pa-2" xs12 sm4 md2>
                  <b-form-group
                    center
                    id="time"
                    :label="
                      $t('servicios.formularioExpedicion.recogidaHoraInicial')
                    "
                    label-for="time"
                  >
                    <b-form-input
                      autocomplete="off"
                      id="time"
                      type="time"
                      v-model="servicio.RecogidaHoraInicial"
                    ></b-form-input>
                  </b-form-group>
                </v-flex>
                <v-flex class="pa-2" xs12 sm4 md2>
                  <b-form-group
                    center
                    id="time"
                    :label="
                      $t('servicios.formularioExpedicion.recogidaHoraInicial')
                    "
                    label-for="time"
                  >
                    <b-form-input
                      autocomplete="off"
                      id="time"
                      type="time"
                      v-model="servicio.RecogidaHoraFinal"
                    ></b-form-input>
                  </b-form-group>
                </v-flex>
              </v-layout>
            </v-card-text>

            <v-card-text v-if="!servicio"
              >Carga un archivo de configuración</v-card-text
            >
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout v-else>
        <v-flex xs12>
          <v-card class="elevation-4" v-if="true">
            <v-toolbar dense color="primary" dark flat>
              <v-toolbar-title>
                {{ $t("servicios.servicioRapido") }}
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <b>{{ $t("servicios.cargandoConfiguracion") }}</b>
              <br />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import UploadButton from "../components/UploadButton";
import PackageList from "../components/expeditions/ExpeditionPackagesV2";
import { mapActions, mapGetters, mapState } from "vuex";
import queryString from "query-string";

export default {
  name: "ExpedicionRapida",
  components: {
    UploadButton,
    PackageList,
  },
  data() {
    return {
      loading: false,
      Comunidades: [],
      Comunidad: "",
      Provincias: [],
      Provincia: "",
      Poblaciones: [],
      CodigosPostales: [],
      Provincia_s: "",
      Comunidad_s: "",
      Poblacion_s: "",
      CodigoPostal_s: "",

      servicio: null,
      configuracion: null,
      servicioSeleccionado: null,
      servicesTypes: [],
      ocultarCamposCargados: false, //TODO cambiar a true
      camposOcultos: [],
      selectedAddressRemitente: null,
      selectedAddressDestinatario: null,
      validations: {
        emailRules: [
          //v => !!v || "E-mail necesario",
          (v) =>
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v
            ) ||
            /^$/.test(v) ||
            "E-mail no válido",
        ],
        standarRules: [(v) => !!v || "Campo necesario"],
        codigoPostalDestinatario: [
          (v) =>
            this.codigoPostalDestinatarioNecesario(v) ||
            "Código Postal obligatorio en este país",
        ],
      },
    };
  },
  created: async function () {
    let temp = await this.getConfiguracionApi(this.Login.DATOS.CLIENTE);
    if (temp.estado) {
      this.configuracion = temp.respuesta;
    }
    //this.configuracion = this.getConfiguracionVuex();
    if (this.configuracion && this.configuracion !== undefined) {
      this.procesarConfiguracion();
    }
    this.establecerHorarioRecogida();
    this.cargarTiposServicio();
    if (!this.addresses || this.addresses.length === 0) {
      console.log("Cargando direcciones");
      await this.fetchAddresses(this.filtro);
    }
  },
  methods: {
    //Autocompletado Destinatario
    async filtrarAPI() {
      if (this.loading || !this.destinatarioPaisCercano) return;
      this.loading = true;
      let filtro = {
        ServicioRapido: true,
        Pais: this.servicio.Destinatario.Pais,
        Comunidad: this.Comunidad ? this.Comunidad : this.Comunidad_s,
        Provincia: this.Provincia ? this.Provincia : this.Provincia_s,
        Poblacion: this.servicio.Destinatario.Poblacion
          ? this.servicio.Destinatario.Poblacion
          : this.Poblacion_s,
        CodigoPostal: this.CodigoPostal_s
          ? this.CodigoPostal_s
          : this.servicio.Destinatario.CodigoPostal,
      };

      let res = await fetch(
        this.$apiRoute + "Localizacion/?" + queryString.stringify(filtro),
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + window.localStorage.getItem("_token"),
          },
        }
      );
      let response = await res.json();

      this.Provincias = response.Provincias;
      this.Poblaciones = response.Poblaciones;
      this.CodigosPostales = response.Cp;
      this.Comunidades = response.Comunidades;

      if (this.destinatarioPaisCercano) {
        if (this.Comunidades.length === 1)
          this.servicio.Destinatario.Comunidad = this.Comunidades[0];
        if (this.Provincias.length === 1)
          this.servicio.Destinatario.Provincia = this.Provincias[0];
        if (this.Poblaciones.length === 1)
          this.servicio.Destinatario.Poblacion = this.Poblaciones[0];
        if (this.CodigosPostales.length === 1)
          this.servicio.Destinatario.CodigoPostal = this.CodigosPostales[0];
      }

      this.loading = false;
    },
    codigoPostalDestinatarioNecesario(v) {
      if (v) return true;
      if (!this.servicio.Destinatario.Pais) return false;
      if (
        this.servicio.Destinatario.Pais !== "ESPAÑA" &&
        this.servicio.Destinatario.Pais !== "ANDORRA" &&
        this.servicio.Destinatario.Pais !== "PORTUGAL"
      )
        return true;
      return false;
    },
    limpiarDireccion() {
      this.loading = true;
      this.Provincia = null;
      this.Comunidad = null;
      this.servicio.Destinatario.CodigoPostal = null;
      //this.selectedAddress.Pais = "ESPAÑA";
      this.servicio.Destinatario.Poblacion = null;
      this.servicio.Destinatario.Provincia = null;
      this.filtrarAPI();
      this.loading = false;
    },

    //Tipos de servicio
    ...mapActions("servicesTypes", ["fetchServicesTypes"]),
    async cargarTiposServicio() {
      this.$store.commit("setLoading", true, { root: true });
      try {
        let filtro = {
          PaisOrigen: this.servicio.Remitente.Pais,
          CodigoPostalOrigen: this.servicio.Remitente.CodigoPostal,
          PaisDestino: this.servicio.Destinatario.Pais,
          CodigoPostalDestino: this.servicio.Destinatario.CodigoPostal,
        };

        let tiposServicios = await this.fetchServicesTypes(filtro);
        this.servicesTypes = tiposServicios;

        if (this.servicio.CodigoTipoServicio) {
          let temp = this.servicesTypes.filter(
            (s) => s.CODIGO === this.servicio.CodigoTipoServicio
          );
          if (temp) this.servicioSeleccionado = temp[0];
        }
      } catch (error) {}

      this.$store.commit("setLoading", false, { root: true });
    },
    actualizarServicio() {
      if (this.servicioSeleccionado)
        this.servicio.CodigoTipoServicio = this.servicioSeleccionado.CODIGO;
    },

    //Horario recogida
    establecerHorarioRecogida() {
      const dt = new Date(this.servicio.Fecha);
      console.log("Día de la semana: " + dt.getDay()); //El viernes es el 5
      if (dt.getDay() === 5) {
        this.servicio.RecogidaHoraInicial = this.configuracion.Horarios.Vier.Inicio;
        this.servicio.RecogidaHoraFinal = this.configuracion.Horarios.Vier.Fin;
      } else {
        this.servicio.RecogidaHoraInicial = this.configuracion.Horarios.LunJue.Inicio;
        this.servicio.RecogidaHoraFinal = this.configuracion.Horarios.LunJue.Fin;
      }
      this.$forceUpdate();
    },

    //Direcciones
    estableceDireccionRemitente() {
      let direccionOrigen = this.selectedAddressRemitente;
      if (!direccionOrigen) return;
      this.servicio.Remitente.Nombre = direccionOrigen.Nombre;
      this.servicio.Remitente.Email = direccionOrigen.Email;
      this.servicio.Remitente.Telefono = direccionOrigen.Telefono;
      this.servicio.Remitente.Pais = direccionOrigen.Pais;
      this.servicio.Remitente.CodigoPostal = direccionOrigen.CodigoPostal;
      this.servicio.Remitente.Poblacion = direccionOrigen.Poblacion;
      this.servicio.Remitente.Direccion = direccionOrigen.Direccion;
      this.servicio.Remitente.Observacion = direccionOrigen.Observacion;
      this.selectedAddressRemitente = null;
    },
    estableceDireccionDestinatario() {      
      let direccionOrigen = this.selectedAddressDestinatario;
      if (!direccionOrigen) return;
      this.servicio.Destinatario.Nombre = direccionOrigen.Nombre;
      this.servicio.Destinatario.Email = direccionOrigen.Email;
      this.servicio.Destinatario.Telefono = direccionOrigen.Telefono;
      this.servicio.Destinatario.Pais = direccionOrigen.Pais;
      this.servicio.Destinatario.CodigoPostal = direccionOrigen.CodigoPostal;
      this.servicio.Destinatario.Poblacion = direccionOrigen.Poblacion;
      this.Poblacion_s = direccionOrigen.Poblacion;
      this.CodigoPostal_s = direccionOrigen.CodigoPostal;
      this.servicio.Destinatario.Direccion = direccionOrigen.Direccion;
      this.servicio.Destinatario.Observacion = direccionOrigen.Observacion;
      this.selectedAddressDestinatario = null;
    },

    //Carga de fichero
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsText(file);
      });
    },
    async cargarConfiguracion(file) {
      //Carga la configuración desde un archivo, obsoleto
      try {
        const reader = new FileReader();
        let contentBuffer = await this.readFileAsync(file);
        this.configuracion = JSON.parse(contentBuffer);
        this.procesarConfiguracion(); //Cualquier cosa incorrecta hace throw
        this.setConfiguracionVuex(this.configuracion);
        this.$toast("Archivo de configuración cargado", {
          color: "green",
        });
      } catch (e) {
        this.$toast("Archivo de configuración incorrecto", {
          color: "red",
        });
      }
    },

    //Procesamiento de la configuración
    procesarConfiguracion() {
      if (!this.configuracion) return;
      this.servicio = {
        GUID: 0,
        Estado: "",
        Observaciones: "",
        Codigo: Date.now(),
        RecogerCliente: true,
        SolicitudCliente: false,
        CodigoCliente: "",
        OrdenServicio: "",
        CodigoTipoServicio: 0,
        NombreCliente: "",
        Fecha: this.obtenerFecha(),
        Referencia: "",
        FechaPrevista: "",
        EntregaSabado: false,
        Hora: this.obtenerHora(),
        AcuseRecibo: false,
        Retorno: false,
        Gestion: "",
        ImporteValor: 0,
        ImporteReembolso: 0,
        ImporteCobroACuenta: 0,
        ImporteDebido: false,
        PesoTotal: 0,
        NumBultos: 0,
        ReferenciaVia: "",
        Remitente: {
          AvisoEmailDestino: false,
          AvisoEmailRemitente: false,
          AvisoSmsDestino: false,
          AvisoSmsRemitente: false,
          Codigo: "",
          CodigoCliente: "",
          CodigoPostal: "",
          Corporativo: "",
          DepartamentoCliente: "",
          Direccion: "",
          Email: "",
          Id: "",
          IdCliente: "",
          IdDomicilio: "",
          IdPais: "",
          IdPoblacion: "",
          Latitud: 0,
          Longitud: 0,
          Marca: "",
          MasDatos: "",
          Movil: 0,
          Nombre: "",
          Nombre2: "",
          NumeroDireccion: 0,
          Observacion: "",
          PisoDireccion: "",
          Poblacion: 0,
          Pointer: "",
          Referencia: "",
          Telefono: "",
          TipoDireccion: "c/",
          Pais: "España",
          Nif: 0,
        },
        Destinatario: {
          AvisoEmailDestino: false,
          AvisoEmailRemitente: false,
          AvisoSmsDestino: false,
          AvisoSmsRemitente: false,
          Codigo: "",
          CodigoCliente: "",
          CodigoPostal: "",
          Corporativo: "",
          DepartamentoCliente: "",
          Direccion: "",
          Email: "",
          Id: "",
          IdCliente: "",
          IdDomicilio: "",
          IdPais: "",
          IdPoblacion: "",
          Latitud: 0,
          Longitud: 0,
          Marca: "",
          MasDatos: "",
          Movil: 0,
          Nombre: "",
          Nombre2: "",
          NumeroDireccion: 0,
          Observacion: "",
          PisoDireccion: "",
          Poblacion: 0,
          Pointer: "",
          Referencia: "",
          Telefono: "",
          TipoDireccion: "c/",
          Pais: "ESPAÑA",
          Nif: 0,
        },
        Bultos: [],
        TipoServicio: {
          Codigo: null,
          Nombre: "",
        },
      };

      this.mapearString("Referencia");
      this.mapearString("CodigoTipoServicio");
      this.mapearString("SolicitudCliente"); //Solicitud de recogida

      this.mapearString("Remitente_Nombre");
      this.mapearString("Remitente_Email");
      this.mapearString("Remitente_Telefono");
      this.mapearString("Remitente_Nif");
      this.mapearString("Remitente_Pais");
      this.mapearString("Remitente_CodigoPostal");
      this.mapearString("Remitente_Poblacion");
      this.mapearString("Remitente_Provincia");
      this.mapearString("Remitente_Direccion");
      this.mapearString("Remitente_Observacion");

      this.mapearString("Destinatario_Nombre");
      this.mapearString("Destinatario_Email");
      this.mapearString("Destinatario_Telefono");
      this.mapearString("Destinatario_Nif");
      this.mapearString("Destinatario_Pais");
      this.mapearString("Destinatario_CodigoPostal");
      this.mapearString("Destinatario_Poblacion");
      this.mapearString("Destinatario_Provincia");
      this.mapearString("Destinatario_Direccion");
      this.mapearString("Destinatario_Observacion");

      this.mapearString("EntregaSabado");
      this.mapearString("AcuseRecibo");
      this.mapearString("Retorno");
      this.mapearString("Gestion");
      this.mapearString("AvisoEmailRemitente");
      this.mapearString("AvisoEmailDestino");

      //Carga bultos
      this.servicio.Bultos = this.configuracion.Bultos;

      this.mapearString("ImporteValor");
      this.mapearString("ImporteReembolso");
      this.mapearString("ImporteDebido");
    },
    obtenerFecha() {
      const toTwoDigits = (num) => (num < 10 ? "0" + num : num);
      let today = new Date();
      let year = today.getFullYear();
      let month = toTwoDigits(today.getMonth() + 1);
      let day = toTwoDigits(today.getDate());
      return `${year}-${month}-${day}`;
    },
    obtenerHora() {
      const toTwoDigits = (num) => (num < 10 ? "0" + num : num);
      let today = new Date();
      let hora = toTwoDigits(today.getHours());
      let minuto = toTwoDigits(today.getMinutes());
      return `${hora}:${minuto}`;
    },
    mapearString(campo) {
      if (campo.includes("_")) {
        let temp = campo.split("_");
        let objetoConfig = this.configuracion[temp[0]];
        let objetoServicio = this.servicio[temp[0]];
        if (objetoConfig && objetoServicio && objetoConfig[temp[1]]) {
          objetoServicio[temp[1]] = objetoConfig[temp[1]];
          this.camposOcultos.push(campo);
        }
      } else {
        if (this.configuracion[campo]) {
          this.servicio[campo] = this.configuracion[campo];
          this.camposOcultos.push(campo);
        }
      }
    },

    //Otros
    esCampoOculto(campo) {
      if (!this.ocultarCamposCargados) return false;
      return (
        this.camposOcultos.includes(campo) ||
        this.configuracion.ForzadoDefinido.includes(campo)
      );
    },
    async guardar(imprimir) {
      this.$store.commit("setLoading", true, { root: true });

      this.servicio.TipoServicio.code = this.servicio.CodigoTipoServicio; //Por si acaso compadre

      let ok = await this.createService(this.servicio);
      if (ok.estado) {
        if (imprimir) {
          let numeroExpedicion =
            ok.respuesta.GrabarExpedicionSolicitudOSXML.EXPEDICION
              .REFERENCIAENTREGA;
          let numeroOrden =
            ok.respuesta.GrabarExpedicionSolicitudOSXML.EXPEDICION.NUMERO;
          await this.imprmir(numeroExpedicion, numeroOrden);
        }
        //this.$router.push("/servicios");
        this.procesarConfiguracion(); //Reiniciar
      }

      this.$store.commit("setLoading", false, { root: true });
    },
    async imprmir(numeroExpedicion, numeroOrden) {
      this.$store.commit("setLoading", true, { root: true });
      let ruta =
        this.$apiRoute +
        "expediciones/etiqueta?numeroExpedicion=" +
        numeroExpedicion +
        "&numeroOrden=" +
        numeroOrden;
      let res = await fetch(ruta, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("_token"),
        },
      });

      if (!res.ok) {
        this.$store.commit("setLoading", false, { root: true });
        this.$toast("No se pudo imprimir", { color: "blue" });
        return;
      }

      let b64 = await res.json();
      b64 = "data:application/pdf;base64," + b64.ImprimirEtiqueta;
      res = await fetch(b64);
      let response = await res.blob();
      let blob = new Blob([response], { type: "application/pdf" });
      var fileUrl = URL.createObjectURL(blob);
      var wnd = window.open(fileUrl, "_blank");
      this.$store.commit("setLoading", false, { root: true });

      await this.sleep(500);
      try {
        wnd.print();
      } catch (error) {}

      /*let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Etiqueta-" + numeroExpedicion + ".pdf";*/
      //link.click();
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    //Vuex
    ...mapActions("addresses", ["fetchAddresses"]),
    ...mapActions({ createService: "services/addService" }),
    ...mapActions({
      getConfiguracionApi: "servicioRapido/getConfiguracionApi",
    }),
    //...mapGetters("servicioRapido", ["getConfiguracionVuex"]),
    //...mapActions("servicioRapido", ["setConfiguracionVuex"]),
    ...mapState(["isMobile"]),
  },
  computed: {
    ...mapGetters({ Login: "Auth/Usuario" }),
    ...mapGetters("addresses", ["addresses", "defecto"]),
    ...mapState("addresses", ["filtro"]), //Para las direcciones (?) no se
    destinatarioPaisCercano: function () {
      const pais = this.servicio.Destinatario.Pais.toUpperCase();
      return pais === "ESPAÑA" || pais === "ANDORRA" || pais === "PORTUGAL";
    },
  },
  watch: {
    Poblacion_s: function (newVal, oldVal) {
      if (newVal === "") this.limpiarDireccion();
      else this.filtrarAPI();
    },
    CodigoPostal_s: function (newVal, oldVal) {
      this.filtrarAPI();
    },
    Comunidad_s: function (newVal, oldVal) {
      this.filtrarAPI();
    },
    Provincia_s: function (newVal, oldVal) {
      this.filtrarAPI();
    },
  },
};
</script>
